/* Shim for the forked design editor: StudioCore toasts → the Brightivity notices (bottom right). */
import { usePrintStore } from '../features/print/PrintStore.jsx';

export function useToast() {
  const s = usePrintStore();
  const n = (tone) => (msg, ms) => s && s.notify(String(msg || ''), tone, ms || (tone === 'coral' ? 6000 : 3500));
  return { showSuccess: n('green'), showError: n('coral'), showWarning: n('yellow'), showInfo: n('green') };
}
export default null;
